import { UIRouter, Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { resolveStateParams } from '../global/resolves/params.resolve';
import { ButtonsMyComponent } from './myButtons/myButtons.component';
import { ButtonsSingleComponent } from './single/single.component';
import { resolveWaitForUser } from '../auth/resolves/waitForUser.resolve';
import { resolveAuthenticated } from '../auth/resolves/authenticated.resolve';
import { buttonVoucherRedirectTo } from './redirects/voucher.redirect';

export const STATES: Ng2StateDeclaration[] = [
  {
    name: 'main.buttons',
    abstract: true
  },
  {
    name: 'main.buttons.my',
    url: '/my-buttons',
    views: {
      '$default@': { component: ButtonsMyComponent }
    },
    resolve: [
      resolveStateParams,
      resolveWaitForUser,
      resolveAuthenticated
    ],
    params: {
      header: {
        backTo: null
      },
      loader: {
        end: false,
        start: true
      },
      scrollToLastBoughtButton: false
    }
  },
  {
    name: 'main.buttons.single',
    url: '/my-button/:code',
    views: {
      '$default@': { component: ButtonsSingleComponent }
    },
    resolve: [
      resolveStateParams,
      resolveWaitForUser
    ],
    params: {
      loader: {
        end: false,
        start: true
      }
    }
  },
  {
    name: 'main.buttons.voucher',
    url: '/button/:code',
    redirectTo: buttonVoucherRedirectTo
  }
];


// WEBPACK FOOTER //
// ./src/app/buttons/buttons.states.ts